export enum TrophyTier {
  BRONZE = "BRONZE",
  SILVER = "SILVER",
  GOLD = "GOLD",
  PLATINUM = "PLATINUM",
  DIAMOND = "DIAMOND",
}

export enum TrophyKey {
  REF_QUALIFIED = "REF_QUALIFIED",
  SOC_TOTAL_VIEWS = "SOC_TOTAL_VIEWS",
  COMP_PARTICIPATE = "COMP_PARTICIPATE",
  COMP_PLACE = "COMP_PLACE",
  SOC_FOLLOWING = "SOC_FOLLOWING",
  SOC_FOLLOWERS = "SOC_FOLLOWERS",
  SOC_CLIP_VIEWS = "SOC_CLIP_VIEWS",
  SOC_CLIP_LIKES = "SOC_CLIP_LIKES",
  STRK_LOGIN = "STRK_LOGIN",
  STRK_CLIP = "STRK_CLIP",
  CRT_CLIPS = "CRT_CLIPS",
  CRT_MONTAGES = "CRT_MONTAGES",
  STRK_DAILY_CLAIM = "STRK_DAILY_CLAIM",
  CRT_COMMAND = "CRT_COMMAND",
  CRT_AUTOCAPTURE = "CRT_AUTOCAPTURE",
}

// Derived client-side (see getTrophyProgress in Utilities/Trophy) from a
// trophy's raw `value` plus its TrophyDefinition.thresholds — the API only
// exposes the raw metric value, not a ready-made "progress to next tier"
// shape.
export interface ITrophyProgress {
  current: number;
  target: number;
  // null once the trophy is already at DIAMOND — nothing further to progress
  // toward.
  nextTier: TrophyTier | null;
}

// key/category/name are typed as `string` rather than the closed enums above
// since the schema only guarantees they resolve to a known TrophyKey/category
// in practice — an unrecognized key still comes back with category/name null
// rather than a GraphQL error.
export interface ITrophy {
  key: string;
  tier: TrophyTier;
  category: string | null;
  name: string | null;
  featuredPosition: number | null;
  // Raw metric value backing this trophy (e.g. follower count, clips
  // created) — combine with the matching TrophyDefinition.thresholds via
  // getTrophyProgress to get progress toward the next tier.
  value?: number | null;
}

export interface ITrophyDefinition {
  key: string;
  category: string;
  name: string;
  metric: string;
  description: string;
  thresholds: Record<string, number>;
}

export interface ITrophyMutationError {
  code: string;
  field: string;
  message: string;
}
